"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardButtonMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _focusMixin = require("../focusMixin");
var _hoverMediaQueryMixin = require("../hoverMediaQueryMixin");
var _spaceMixin = require("../spaceMixin");
var _spacingMixin = require("../spacingMixin");
var _typographyMixin = require("../typographyMixin");
/** @class CardButtonMixin */
/** @method */
var CardButtonMixin = function CardButtonMixin(props) {
  return (0, _styledToken.default)({
    borderColor: 'Card.separatorColor',
    borderWidthTop: 'CardButton.borderWidthTop',
    color: 'CardButton.fontColor',
    fontType: 'CardButton.fontType',
    hoverTextDecoration: 'CardButton.textDecoration.hover',
    marginTop: 'CardButton.marginTop',
    padding: 'CardButton.padding',
    paddingTop: 'CardButton.paddingTop',
    textAlign: 'CardButton.textAlign',
    width: 'CardButton.width'
  }, function (_ref) {
    var borderColor = _ref.borderColor,
      _ref$borderWidthTop = _ref.borderWidthTop,
      borderWidthTop = _ref$borderWidthTop === void 0 ? 1 : _ref$borderWidthTop,
      color = _ref.color,
      fontType = _ref.fontType,
      _ref$hoverTextDecorat = _ref.hoverTextDecoration,
      hoverTextDecoration = _ref$hoverTextDecorat === void 0 ? 'underline' : _ref$hoverTextDecorat,
      _ref$padding = _ref.padding,
      padding = _ref$padding === void 0 ? 0 : _ref$padding,
      marginTop = _ref.marginTop,
      paddingTop = _ref.paddingTop,
      _ref$textAlign = _ref.textAlign,
      textAlign = _ref$textAlign === void 0 ? 'center' : _ref$textAlign,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '100%' : _ref$width;
    return (0, _styledComponents.css)(["", " color:", ";padding:", "px;border:0;background:transparent;text-align:", ";border-top:", "px solid ", ";display:block;width:", ";padding-top:", ";margin-top:", ";cursor:pointer;outline:none;", " ", ";", ""], (0, _typographyMixin.typographyMixin)(Object.assign({
      fontType: fontType
    }, props)), color, padding, textAlign, borderWidthTop, borderColor, width, paddingTop ? paddingTop + "px" : (0, _spaceMixin.spaceMixin)('sm')(props), marginTop ? marginTop + "px" : (0, _spaceMixin.spaceMixin)('md')(props), (0, _focusMixin.focusMixin)(props), (0, _hoverMediaQueryMixin.hoverMediaQueryMixin)("\n                text-decoration: " + hoverTextDecoration + ";\n            "), (0, _spacingMixin.spacingMixin)(props));
  })(props);
};
exports.CardButtonMixin = CardButtonMixin;